/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSymbol3D as o } from "../../symbols.js";
import e from "../../core/Error.js";
import r from "../WebStyleSymbol.js";
import m from "../PointSymbol3D.js";
import i from "../SimpleLineSymbol.js";
import l from "../LineSymbol3D.js";
import n from "../SimpleMarkerSymbol.js";
import t from "../PictureMarkerSymbol.js";
import s from "../SimpleFillSymbol.js";
import y from "../PolygonSymbol3D.js";
import f from "../TextSymbol.js";
import b from "../LabelSymbol3D.js";
var p = {
  retainId: !1,
  ignoreDrivers: !1,
  hasLabelingContext: !0
};

function a(a) {
  var S = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : p;
  if (!a) return {
    symbol: null
  };
  var _S$retainId = S.retainId,
      c = _S$retainId === void 0 ? p.retainId : _S$retainId,
      _S$ignoreDrivers = S.ignoreDrivers,
      u = _S$ignoreDrivers === void 0 ? p.ignoreDrivers : _S$ignoreDrivers,
      _S$hasLabelingContext = S.hasLabelingContext,
      d = _S$hasLabelingContext === void 0 ? p.hasLabelingContext : _S$hasLabelingContext,
      _S$retainCIM = S.retainCIM,
      j = _S$retainCIM === void 0 ? p.retainCIM : _S$retainCIM;
  var D;
  if (o(a) || a instanceof r) D = a.clone();else if ("cim" === a.type) {
    var g, C;

    var _o = null == (g = a.data) || null == (C = g.symbol) ? void 0 : C.type;

    if ("CIMPointSymbol" !== _o) return {
      error: new e("symbol-conversion:unsupported-cim-symbol", "CIM symbol of type '".concat(_o || "unknown", "' is unsupported in 3D"), {
        symbol: a
      })
    };
    D = j ? a.clone() : m.fromCIMSymbol(a);
  } else if (a instanceof i) D = l.fromSimpleLineSymbol(a);else if (a instanceof n) D = m.fromSimpleMarkerSymbol(a);else if (a instanceof t) D = m.fromPictureMarkerSymbol(a);else if (a instanceof s) D = y.fromSimpleFillSymbol(a);else {
    if (!(a instanceof f)) return {
      error: new e("symbol-conversion:unsupported-2d-symbol", "2D symbol of type '".concat(a.type || a.declaredClass, "' is unsupported in 3D"), {
        symbol: a
      })
    };
    D = d ? b.fromTextSymbol(a) : m.fromTextSymbol(a);
  }
  if (c && "cim" !== D.type && (D.id = a.id), u && o(D)) for (var _o2 = 0; _o2 < D.symbolLayers.length; ++_o2) {
    D.symbolLayers.getItemAt(_o2)._ignoreDrivers = !0;
  }
  return {
    symbol: D
  };
}

export { a as to3D };